module.exports = __webpack_public_path__ + "static/media/product_16_white.d2493b2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/product_16_white.svg
// module id = 1405
// module chunks = 0